import React from "react";
import { Helmet } from "react-helmet-async";
import { match as Match } from "react-router-dom";
import { injectIntl, IntlShape } from "react-intl";
import { withOneColLayout } from "../../../../utils";
import PageSubheader from "../../../../components/PageSubheader";
import PriceUnitVariationForm from "../form";

interface Props {
  match: Match<{ id: string }>;
  intl: IntlShape;
  backURL: string;
}

const UpdatePriceUnitVariation = (props: Props) => {
  const { intl, backURL } = props;

  return (
    <>
      <Helmet>
        <title>
          {intl.formatMessage({
            id: "page.price.unit.variation.update.document.title",
          })}
        </title>
      </Helmet>

      <PageSubheader
        goBackEnabled
        goBackId="btn-back-price-unit-variation-update"
        goBackURL={backURL}
      />

      <PriceUnitVariationForm {...props} edition />
    </>
  );
};

export default withOneColLayout(injectIntl(UpdatePriceUnitVariation));
